export default "__VITE_PUBLIC_ASSET__d0638d30__"